module.exports = __webpack_public_path__ + "img/1.9195a67f.png";